import type { ToastInput } from '../components/ui/toast';

/**
 * The four toasts of Figma P01, as ready-made inputs: `toast(toasts.saved())`. Copy stays short and plain; the tone
 * (and so the icon) is decided here so every screen says the same thing the same way.
 */
export const toasts = {
  /** Green tick. Pass `undo` only when the action can really be undone. */
  saved: (description?: string, undo?: () => void): ToastInput => ({
    title: 'Saved',
    description,
    tone: 'success',
    action: undo ? { label: 'Undo', onClick: undo } : undefined,
  }),
  /** Green tick with a custom title ("Copied", "Link copied", "Sent to the client"). */
  done: (title: string, description?: string): ToastInput => ({ title, description, tone: 'success' }),
  /** Amber clock: a rate limit or "wait a moment". */
  rateLimited: (title = 'Too many tries', description = 'Wait a minute, then try again.'): ToastInput => ({
    title,
    description,
    tone: 'warning',
  }),
  /** Amber sparkle: a control whose feature isn't open yet. */
  comingSoon: (description: string): ToastInput => ({ title: 'Coming soon', description, tone: 'info' }),
  /** Red cross. Pass `retry` when trying the same thing again makes sense. */
  failed: (
    title = 'Couldn’t save',
    description = 'Something went wrong on our side. Try again.',
    retry?: () => void,
  ): ToastInput => ({
    title,
    description,
    tone: 'error',
    action: retry ? { label: 'Retry', onClick: retry } : undefined,
  }),
};
